module.exports = __webpack_public_path__ + "/img/Molded-Custom-Footprint-yepWJc.svg";